import type Product from './Product';

export class Basic {
  title: string;
  type: any;
  categories: number[];
  description: string;
  image_url: string;
  image_id: number;
  constructor(product: Product) {
    this.title = product.title || '';
    this.type = product.type;
    this.categories = product.categories;
    this.description = product.description || '';
    this.image_url = product.image_url || '';
    this.image_id = product.image_id;
  }
}

export class Details {
  prelaunch: boolean;
  launch_date: any;
  sales_expectation: number;
  has_expiration_date: boolean;
  expiration_date: any;
  alternative_url: string;
  friendly_name: string;
  author_name: string;
  program_content: string;
  email_welcome: boolean;
  constructor(product: Product) {
    this.prelaunch = product.prelaunch || false;
    this.launch_date = product.launch_date || '';
    this.has_expiration_date = product.has_expiration_date || false;
    this.sales_expectation = product.sales_expectation || 0;
    this.expiration_date = product.expiration_date || '';
    this.alternative_url = product.alternative_url || '';
    this.friendly_name = product.friendly_name || '';
    this.author_name = product.author_name || '';
    this.program_content = product.program_content || '';
    this.email_welcome = product.email_welcome;
  }
}

export class SupportRefund {
  support_email: string;
  refund_days: number;
  constructor(product: Product) {
    this.support_email = product.support_email;
    this.refund_days = product.refund_days;
  }
}
